import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityMassyPage() {
  const data = citiesData.find((c) => c.slug === "massy")!;
  return <CityPage data={data} />;
}
